import { useStore } from '../store/index'
// Si el usuario ya aceptó la cookie de Analytics en otra visita, se carga gtag con consentimiento.
// Ref: https://trello.com/c/X9e65E4p
export default defineNuxtPlugin(nuxtApp => {
  const { aceptar } = useConsentimientoGoogle()
  const cookieControl = useCookieControl()
  const store = useStore()
  const gaId = store?.NOTARIA?.Personalizar?.GoogleAnalyticsID
  if (gaId && cookieControl.cookiesEnabledIds.value?.includes('gtag')) {
    aceptar(gaId)
  }
})
